<template>
  <div class="imposicion-container">
    <div
      v-if="!hasAllParams"
      class="missing"
    >
      Faltan definir parámetros de la imposición.
    </div>
    <div
      v-else
      class="svg-wrapper"
      :style="{
        width: displayWidth + 'px',
        height: displayHeight + 'px',
      }"
    >
      <svg
        :viewBox="`-15 -15 ${medidaAlDesarrollo + 30} ${medidaAlEje + 30}`"
        preserveAspectRatio="xMidYMid meet"
        class="svg-root"
        role="img"
        aria-label="Imposición de etiquetas"
      >
        <g class="etiquetas-group">
          <rect
            v-for="(pos, idx) in squares"
            :key="idx"
            :x="pos.x"
            :y="pos.y"
            :width="squareWidth"
            :height="squareHeight"
            fill="#c5d9f1"
            :stroke-width="strokeWidthRect"
          />
        </g>

        <g v-if="!isRotated">
          <line
            x1="0.5"
            y1="0.5"
            :x2="medidaAlDesarrollo - 0.5"
            y2="0.5"
            stroke="black"
            :stroke-width="strokeWidthPaper"
          />
          <line
            x1="0.5"
            :y1="medidaAlEje - 0.5"
            :x2="medidaAlDesarrollo - 0.5"
            :y2="medidaAlEje - 0.5"
            stroke="black"
            :stroke-width="strokeWidthPaper"
          />
        </g>
        <g v-else>
          <line
            x1="0.5"
            y1="0.5"
            x2="0.5"
            :y2="medidaAlEje - 0.5"
            stroke="black"
            :stroke-width="strokeWidthPaper"
          />
          <line
            :x1="medidaAlDesarrollo - 0.5"
            y1="0.5"
            :x2="medidaAlDesarrollo - 0.5"
            :y2="medidaAlEje - 0.5"
            stroke="black"
            :stroke-width="strokeWidthPaper"
          />
        </g>

        <g v-if="!isRotated">
          <line
            x1="0.5"
            y1="0.5"
            x2="0.5"
            :y2="medidaAlEje - 0.5"
            stroke="green"
            :stroke-width="strokeWidthRed"
            stroke-dasharray="4 4"
          />
          <line
            :x1="medidaAlDesarrollo - 0.5"
            y1="0.5"
            :x2="medidaAlDesarrollo - 0.5"
            :y2="medidaAlEje - 0.5"
            stroke="green"
            :stroke-width="strokeWidthRed"
            stroke-dasharray="4 4"
          />
        </g>
        <g v-else>
          <line
            x1="0.5"
            y1="0.5"
            :x2="medidaAlDesarrollo - 0.5"
            y2="0.5"
            stroke="green"
            :stroke-width="strokeWidthRed"
            stroke-dasharray="4 4"
          />
          <line
            x1="0.5"
            :y1="medidaAlEje - 0.5"
            :x2="medidaAlDesarrollo - 0.5"
            :y2="medidaAlEje - 0.5"
            stroke="green"
            :stroke-width="strokeWidthRed"
            stroke-dasharray="4 4"
          />
        </g>

        <g v-if="mostrarSentidoAvance">
          <defs>
            <marker
              id="arrowhead"
              viewBox="0 0 10 10"
              refX="8"
              refY="5"
              markerWidth="6"
              markerHeight="6"
              orient="auto"
            >
              <path
                d="M 0 0 L 10 5 L 0 10 Z"
                fill="black"
              />
            </marker>
          </defs>

          <line
            v-if="rotacion === 0"
            :x1="medidaAlDesarrollo * 0.1"
            :y1="-8"
            :x2="medidaAlDesarrollo * 0.9"
            :y2="-8"
            stroke="black"
            :stroke-width="strokeWidthPaper * 1.5"
            marker-end="url(#arrowhead)"
          />

          <line
            v-else-if="rotacion === 90"
            :x1="medidaAlDesarrollo + 8"
            :y1="medidaAlEje * 0.1"
            :x2="medidaAlDesarrollo + 8"
            :y2="medidaAlEje * 0.9"
            stroke="black"
            :stroke-width="strokeWidthPaper * 1.5"
            marker-end="url(#arrowhead)"
          />

          <line
            v-else-if="rotacion === 180"
            :x1="medidaAlDesarrollo * 0.9"
            :y1="medidaAlEje + 8"
            :x2="medidaAlDesarrollo * 0.1"
            :y2="medidaAlEje + 8"
            stroke="black"
            :stroke-width="strokeWidthPaper * 1.5"
            marker-end="url(#arrowhead)"
          />

          <line
            v-else-if="rotacion === 270"
            :x1="-8"
            :y1="medidaAlEje * 0.9"
            :x2="-8"
            :y2="medidaAlEje * 0.1"
            stroke="black"
            :stroke-width="strokeWidthPaper * 1.5"
            marker-end="url(#arrowhead)"
          />
        </g>
        <text
          v-if="anchoImposicion > 0"
          :x="medidaAlDesarrollo / 2"
          :y="medidaAlEje - 12"
          font-size="12px"
          font-weight="600"
          fill="#333"
          text-anchor="middle"
          dominant-baseline="middle"
        >
          {{ anchoImposicion }} mm
        </text>
        <text
          v-if="largoImposicion > 0"
          :x="medidaAlDesarrollo - 10"
          :y="medidaAlEje / 2"
          font-size="12px"
          font-weight="600"
          fill="#333"
          text-anchor="middle"
          dominant-baseline="middle"
          :transform="`rotate(-90, ${medidaAlDesarrollo - 10}, ${medidaAlEje / 2})`"
        >
          {{ largoImposicion }} mm
        </text>
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  cavidadesAncho: { type: Number, required: true },
  cavidadesDesarrollo: { type: Number, required: true },
  gapDesarrollo: { type: Number, required: true },
  gapEje: { type: Number, required: true },
  laterales: { type: Number, required: true },
  medidaAlEje: { type: Number, required: true },
  medidaAlDesarrollo: { type: Number, required: true },
  minDisplayHeight: { type: Number, default: 200 },
  maxDisplayWidth: { type: Number, default: 450 },
  maxDisplayHeight: { type: Number, default: 300 },
  anchoImposicion: { type: Number, default: 0 },
  largoImposicion: { type: Number, default: 0 },
  aspectRatio: { type: Number, default: 1 },
  rotacion: { type: Number, default: 0 },
  mostrarSentidoAvance: { type: Boolean, default: false },
});

const isRotated = computed(() => [90, 270].includes(props.rotacion));
const hasAllParams = computed(() => {
  return (
    props.cavidadesAncho > 0 &&
    props.cavidadesDesarrollo > 0 &&
    props.medidaAlEje > 0 &&
    props.medidaAlDesarrollo > 0 &&
    props.gapEje >= 0 &&
    props.gapDesarrollo >= 0
  );
});

const rows = computed(() => Math.max(1, Math.round(props.cavidadesAncho)));
const cols = computed(() => Math.max(1, Math.round(props.cavidadesDesarrollo)));

const displayHeight = computed(() => {
  let h = props.maxDisplayWidth / props.aspectRatio;
  h = Math.max(props.minDisplayHeight, h);
  h = Math.min(props.maxDisplayHeight, h);
  let w = h * props.aspectRatio;
  if (w > props.maxDisplayWidth) {
    w = props.maxDisplayWidth;
    h = w / props.aspectRatio;
    if (h < props.minDisplayHeight) {
      h = props.minDisplayHeight;
      w = h * props.aspectRatio;
    }
  }
  return Math.round(h);
});

const displayWidth = computed(() => {
  return Math.round(displayHeight.value * props.aspectRatio);
});

const scale = computed(() => {
  const scaleX = displayWidth.value / props.medidaAlDesarrollo;
  const scaleY = displayHeight.value / props.medidaAlEje;
  return Math.min(scaleX, scaleY);
});

const BASE_RECT = 1;
const MIN_RECT = 0.3;

const BASE_RED = 1.5;
const MIN_RED = 0.2;

const BASE_PAPER = 1;
const MIN_PAPER = 0.2;

const strokeWidthRect = computed(() => {
  return Math.max(MIN_RECT, Math.min(BASE_RECT, BASE_RECT / Math.max(1, scale.value)));
});

const strokeWidthRed = computed(() => {
  return Math.max(MIN_RED, Math.min(BASE_RED, BASE_RED / Math.max(1, scale.value)));
});

const strokeWidthPaper = computed(() => {
  return Math.max(MIN_PAPER, Math.min(BASE_PAPER, BASE_PAPER / Math.max(1, scale.value)));
});

const halfGapDesarrollo = computed(() => props.gapDesarrollo / 2);
const halfGapEje = computed(() => props.gapEje / 2);

const verticalInset = computed(() => strokeWidthRed.value + 0.1);
const horizontalInset = computed(() => strokeWidthPaper.value + 0.1);

const squareWidth = computed(() => {
  const totalHorizGaps = cols.value * props.gapDesarrollo;
  const marginX = isRotated.value ? 2 * props.laterales : 0;
  const available = props.medidaAlDesarrollo - 2 * verticalInset.value - marginX - totalHorizGaps;
  return available > 0 ? available / cols.value : 0;
});

const squareHeight = computed(() => {
  const totalVertGaps = rows.value * props.gapEje;
  const marginY = !isRotated.value ? 2 * props.laterales : 0;
  const available = props.medidaAlEje - 2 * horizontalInset.value - marginY - totalVertGaps;
  return available > 0 ? available / rows.value : 0;
});

const squares = computed(() => {
  const arr = [];
  const offsetLateralesX = isRotated.value ? props.laterales : 0;
  const offsetLateralesY = !isRotated.value ? props.laterales : 0;

  const x0 = verticalInset.value + offsetLateralesX + halfGapDesarrollo.value;
  const y0 = horizontalInset.value + offsetLateralesY + halfGapEje.value;

  for (let r = 0; r < rows.value; r++) {
    for (let c = 0; c < cols.value; c++) {
      arr.push({
        x: x0 + c * (squareWidth.value + props.gapDesarrollo),
        y: y0 + r * (squareHeight.value + props.gapEje),
      });
    }
  }
  return arr;
});
</script>

<style scoped>
.imposicion-container {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.svg-wrapper {
  min-height: 200px;
}
.svg-root {
  width: 100%;
  height: 100%;
  display: block;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  padding: 4px;
  box-sizing: border-box;
  border-radius: 4px;
}
.missing {
  padding: 12px;
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  border-radius: 4px;
  font-weight: 600;
  text-align: center;
  width: 100%;
}
</style>
